import { render, staticRenderFns } from "./ListQuizSubmissions.vue?vue&type=template&id=52f57b6b&scoped=true&"
import script from "./ListQuizSubmissions.vue?vue&type=script&lang=js&"
export * from "./ListQuizSubmissions.vue?vue&type=script&lang=js&"
import style0 from "./ListQuizSubmissions.vue?vue&type=style&index=0&id=52f57b6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f57b6b",
  null
  
)

export default component.exports